import { Component, OnInit } from "@angular/core";
import { UserService } from "../services/user.service";
import { OfframpService } from "../services/offramp.service";
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

import { MatDialog } from "@angular/material";
import * as moment from "moment";
import { NotificationsService } from "angular2-notifications";
import { ColDef, GridOptions, GridApi, ColumnApi } from "ag-grid-community";
import { EditOfframpAdminConfigDialog } from "./edit-offramp-admin-config/edit-offramp-admin-config.component";

const defaults = {
  notif: {
    timeOut: 3000,
    showProgressBar: true,
    pauseOnHover: false,
    clickToClose: true,
    maxLength: 50,
  },
};

@Component({
  selector: "app-offramp-admin-config",
  templateUrl: "./offramp-admin-config.component.html",
  styleUrls: ["./offramp-admin-config.component.css"],
})
export class OfframpAdminConfigComponent implements OnInit {
  _csrf: string;

  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  gridOptions: GridOptions;
  columnDefs: ColDef[] = [];
  rowData: any[] = [];
  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    minWidth: 100
  };

  configs: any = [];

  constructor(
    private router: Router,
    private notifSer: NotificationsService,
    private userService: UserService,
    private offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog
  ) {
    this.initializeGrid();
  }

  ngOnInit() {
    this.csrf();
  }

  initializeGrid() {
    this.columnDefs = [
      {
        headerName: 'Action',
        field: 'action',
        cellRenderer: (params) => {
          const element = params.data;
          const container = document.createElement('div');
          container.style.display = 'flex';
          container.style.alignItems = 'center';

          const editBtn = document.createElement('button');
          editBtn.type = 'button';
          editBtn.className = 'btn btn-sm btn-primary';
          editBtn.title = 'Edit';
          editBtn.innerHTML = '<i class="fa fa-edit"></i>';
          editBtn.onclick = (e) => {
            e.stopPropagation();
            this.editRecord(element);
          };
          container.appendChild(editBtn);

          return container;
        },
        sortable: false,
        filter: false,
        flex: 0.6,
        minWidth: 90
      },
      { headerName: 'Key', field: 'key', flex: 1.5 },
      { headerName: 'Value', field: 'value', flex: 1 },
      {
        headerName: 'Updated At',
        field: 'updatedAt',
        valueFormatter: (params) => {
          if (params.value) {
            return moment(params.value).format('MMM DD, YYYY hh:mm:ss A');
          }
          return '';
        },
        flex: 1.5
      }
    ];

    this.gridOptions = {
      enableCellTextSelection: true,
      ensureDomOrder: true,
      columnDefs: this.columnDefs,
      defaultColDef: this.defaultColDef,
      rowData: this.rowData,
      pagination: false,
      suppressHorizontalScroll: false,
      enableRangeSelection: true,
      animateRows: true,
      rowHeight: 40,
      headerHeight: 40
    };
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  csrf() {
    this.userService.csrf().subscribe(
      (success) => {
        this._csrf = success._csrf;
        this.getData();
      },
      (error) => {
        this.notifSer.error("Error", error.error.message, defaults.notif);
      }
    );
  }

  getData() {
    this.spinnerService.show();
    this.offrampService.getAllOfframpAdminConfig({ _csrf: this._csrf }).subscribe((response: any) => {
      const list = (response && response.data) || [];
      this.configs = list;
      this.rowData = list;

      if (this.gridApi) {
        this.gridApi.setRowData(this.rowData);
      }

      this.spinnerService.hide();
    }, (error) => {
      this.spinnerService.hide();
      this.notifSer.error("Error", (error.error && error.error.message) || "Failed to fetch admin config", defaults.notif);
    });
  }

  editRecord(record: any) {
    const dialogRef = this.dialog.open(EditOfframpAdminConfigDialog, {
      width: '500px',
      data: { record: record, _csrf: this._csrf }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        this.notifSer.success("Success", "Config updated successfully", defaults.notif);
        this.getData();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/offramp-admin-config/offramp-admin-config.component.ts